// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__oMDdO","spinner":"style_spinner__9Vt0K"};